<tg-row class="summary-page-property-information-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Property information</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-property-information-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit property information</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Category:</span
        >
        {{ category }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Address:</span
        >
        {{ address }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Floor area:</span
        >
        {{ floorArea }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Land area:</span
        >
        {{ landAreaWithUnit }}
    </tg-col>
</tg-row>

<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Bedrooms:</span
        >
        {{ bedrooms }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Bathrooms:</span
        >
        {{ bathrooms }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Separate toilets:</span
        >
        {{ toilets }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Ensuite bathrooms:</span
        >
        {{ ensuites }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Living areas / Lounges:</span
        >
        {{ lounges }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Studies:</span
        >
        {{ studies }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Home & income potential:</span
        >
        {{ homeAndIncome }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Garage parking:</span
        >
        {{ garageParking }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Off street parking:</span
        >
        {{ offStreetParking }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isDwellingSubcategory">
    <tg-col class="summary-page-property-information-section__content">
        <span class="summary-page-property-information-section__content-label"
            >Additional details about parking or garaging:</span
        ><br />
        <span class="summary-page-property-information-section__content-value">
            {{ parkingDetails }}
        </span>
    </tg-col>
</tg-row>